/**
 * Global hover panel cleanup utility
 * This helps clean up any orphaned hover panels that might get stuck on the page
 */

export function clearAllHoverPanels() {
  // Remove all photo hover panels
  const photoHoverPanels = document.querySelectorAll('.photo-hover-panel, .photo-cluster-hover-panel')
  photoHoverPanels.forEach(panel => {
    if (panel && panel.parentElement) {
      panel.remove()
    }
  })

  // Remove all POI hover panels
  const poiHoverPanels = document.querySelectorAll('.poi-cluster-hover-panel')
  poiHoverPanels.forEach(panel => {
    if (panel && panel.parentElement) {
      panel.remove()
    }
  })

  // Only log if panels were actually cleaned up
  const totalCleaned = photoHoverPanels.length + poiHoverPanels.length
  if (totalCleaned > 0) {
    console.log(`🧹 Cleaned up ${totalCleaned} orphaned hover panels`)
  }
}

// Track mouse position to detect when mouse leaves the window
let mouseInWindow = true

// Clean up on page visibility changes (when user switches tabs, etc.)
if (typeof document !== 'undefined') {
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      clearAllHoverPanels()
    }
  })

  // Clean up on window blur (when user clicks outside the browser)
  window.addEventListener('blur', () => {
    clearAllHoverPanels()
  })

  // Clean up on escape key press
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      clearAllHoverPanels()
    }
  })

  // Track mouse entering/leaving window
  document.addEventListener('mouseenter', () => {
    mouseInWindow = true
  })

  document.addEventListener('mouseleave', () => {
    mouseInWindow = false
    // Give a short delay in case mouse quickly re-enters
    setTimeout(() => {
      if (!mouseInWindow) {
        clearAllHoverPanels()
      }
    }, 100)
  })

  // Clean up on window resize (can cause positioning issues)
  window.addEventListener('resize', () => {
    clearAllHoverPanels()
  })

  // Clean up on scroll (panels can get misaligned)
  window.addEventListener('scroll', () => {
    clearAllHoverPanels()
  }, { passive: true })
}